import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type AccountRecord = QueryAtomResult<typeof accountsByIdsQueryAtom>[0];

export const accountsByIdsQueryAtom = createQueryAtomFactory(
  'trade.accountsByIds',
  (params: { accountIds: string[] }) => ({
    accounts: {
      __args: {
        filter: {
          ids: params.accountIds,
        },
      },
      page: {
        __scalar: true,
      },
      entries: {
        id: true,
        addresses: {
          id: true,
          name: true,
          address: {
            __scalar: true,
          },
        },
        contacts: {
          id: true,
          __scalar: true,
        },
      },
    },
  }),
  {
    select: (data) => data?.accounts.entries ?? [],
  },
);
